import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../../App/Services/AppService';
import StaticCurrencyLookup from '../../Common/Models/StaticCurrencyLookup';

export interface ICurrencyApiClient {
    getCurrencyList(): AxiosPromise<Array<Model.PlainObject<StaticCurrencyLookup>>>;
}

@injectable()
export default class CurrencyApiClient extends Data.ApiClientBase implements ICurrencyApiClient {
    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/StaticCurrency`);
    }

    public getCurrencyList(): AxiosPromise<Array<Model.PlainObject<StaticCurrencyLookup>>> {
        return this.axios.get(`${this.apiPath}/GetStaticCurrencyList`);
    }
}